import React, { useEffect, useState } from "react";
import Skeleton from "@mui/material/Skeleton";
import axios from "axios";

const GetAfsoRoleBased = ({ dist_code, value, onChange }) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!dist_code) {
            setOptions([]);
            return;
        }

        setLoading(true);
        axios.get(`${process.env.REACT_APP_URL}/api/loginbased/afsoList?distCode=${dist_code}`)
            .then(res => {
                setOptions(res.data);
            })
            .catch(err => console.error(err))
            .finally(() => setLoading(false));
    }, [dist_code]);

    if (loading) return <Skeleton width={200} height={40} />;

    if (options.length === 1 && options[0].afso_code !== "0") {
        return <div>ALL</div>;
    }

    return (
        <select value={value} onChange={(e) => onChange(e.target.value)}>
            <option value=" ">Select </option>
            {options.map(opt => (
                <option key={opt.afso_code} value={opt.afso_code}>
                    {opt.afso_name_en}
                </option>
            ))}
        </select>
    );
};

export default GetAfsoRoleBased;